import React, { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import Login from './Login';
import Register from './Register';

const ProtectedRoute = ({
  children,
  roles = [],
  fallback = null,
  showLoginIfNotAuthenticated = true
}) => {
  const { user, isLoading } = useContext(AuthContext);
  const [isLoginMode, setIsLoginMode] = useState(true);

  // Show loading spinner while checking authentication status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="large" text="Loading..." />
      </div>
    );
  }

  // If not authenticated, show login or custom fallback
  if (!user) {
    if (showLoginIfNotAuthenticated) {
      // Render AuthWrapper-like component to allow switching between login and register
      if (isLoginMode) {
        return <Login onSwitchToRegister={() => setIsLoginMode(false)} />;
      } else {
        return <Register onSwitchToLogin={() => setIsLoginMode(true)} />;
      }
    }
    return fallback || (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Authentication Required
          </h2>
          <p className="text-gray-600">
            You must be logged in to access this page.
          </p>
        </div>
      </div>
    );
  }

  // If roles are specified, check if user has required role
  if (roles.length > 0 && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Access Denied
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            You don't have permission to access this page.
          </p>
          <p className="mt-1 text-sm text-gray-500">
            Required role: {roles.join(' or ')}. Your role: {user.role}
          </p>
          <div className="mt-6">
            <button
              onClick={() => window.history.back()}
              className="text-blue-600 hover:text-blue-500 text-sm font-medium"
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    );
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute;